import React from "react";
import { Link } from "react-router-dom";

// Icons
import ArrowLeft from "~/assets/icons/arrowLeft.svg";
// Styles
import s from "~/components/common/Breadcrumbs/Breadcrumbs.module.scss";

interface Props {
  to: string;
  text: string;
  external?: boolean;
}

const Breadcrumbs: React.FC<Props> = ({ to, text, external }) => {
  const breadcrumbContent = (
    <>
      <img src={ArrowLeft} />
      <span>{text}</span>
    </>
  );

  return external ? (
    <a href={to} className={s.breadcrumb}>
      {breadcrumbContent}
    </a>
  ) : (
    <Link to={{ pathname: `${to}` }} className={s.breadcrumb}>
      {breadcrumbContent}
    </Link>
  );
};

export default Breadcrumbs;
